'use client';

import { useEffect, useState } from 'react';

import { getAppDisplayVersion } from './get-app-display-version';
import { getVersionApp } from './get-version-app';

export function useAppDisplayVersion(): string {
  const fallbackVersion = getVersionApp() ?? '';
  const [version, setVersion] = useState(fallbackVersion);

  useEffect(() => {
    let cancelled = false;

    void getAppDisplayVersion().then((nextVersion) => {
      if (!cancelled) {
        setVersion(nextVersion);
      }
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return version;
}
